var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHamburger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "12px",
    viewBox: "0 0 14 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "D3FB7D25-9FE0-41CC-B212-AF873CC5BFFE") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "header-button-titlescreen",
    transform: "translate(-20.000000, -21.000000)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("g", {
    id: "menu-button",
    transform: "translate(20.000000, 21.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    x: 0,
    y: 0,
    width: 14,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    x: 0,
    y: 5,
    width: 14,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    x: 0,
    y: 10,
    width: 14,
    height: 2
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburger);
export default __webpack_public_path__ + "static/media/hamburger.0ac0c3a1e1bf63441be7f4d9e7783aef.svg";
export { ForwardRef as ReactComponent };